export default {
  tabChatVis: false
}
